// src/pages/Volunteer.js
import React, { useState } from 'react';
import { Handshake, CheckCircle, Loader } from 'lucide-react';
import { submitVolunteer } from '../utils/airtable';
import './Volunteer.css';

const INTERESTS = [
  'Canvassing', 'Phone banking', 'Event staffing',
  'Voter registration', 'Poll working', 'Data entry',
];

const Volunteer = ({ county }) => {
  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', phone: '', interests: [],
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggleInterest = (interest) => {
    setForm(prev => ({
      ...prev,
      interests: prev.interests.includes(interest)
        ? prev.interests.filter(i => i !== interest)
        : [...prev.interests, interest],
    }));
  };

  const handleSubmit = async () => {
    if (!form.firstName || !form.lastName || !form.email) {
      setError('Please fill in your first name, last name, and email.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await submitVolunteer(form);
      setSubmitted(true);
    } catch (err) {
      setError('Could not submit your signup. Please try again or contact us directly.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div>
        <div className="sec-head">
          <div className="sec-icon"><Handshake size={20} color="currentColor" style={{ verticalAlign: 'middle' }} /></div>
          <div><div className="sec-title">Volunteer with us</div></div>
        </div>
        <div className="success-msg" style={{ fontSize: 15, padding: 20 }}>
          <CheckCircle size={16} color="currentColor" style={{ verticalAlign: 'middle' }} /> Thanks for signing up! A member of our team will be in touch soon.
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="sec-head">
        <div className="sec-icon"><Handshake size={20} color="currentColor" style={{ verticalAlign: 'middle' }} /></div>
        <div>
          <div className="sec-title">Volunteer with us</div>
          <div className="sec-desc">Help elect Republicans across {county?.name || 'Larimer County'}</div>
        </div>
      </div>

      <div className="vol-form">
        <div className="form-grid-2">
          <div className="form-group">
            <label className="form-label">First name <span className="required">*</span></label>
            <input type="text" placeholder="Jane" value={form.firstName} onChange={e => setForm({...form, firstName: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">Last name <span className="required">*</span></label>
            <input type="text" placeholder="Doe" value={form.lastName} onChange={e => setForm({...form, lastName: e.target.value})} />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Email address <span className="required">*</span></label>
          <input type="email" placeholder="jane@example.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        </div>

        <div className="form-group">
          <label className="form-label">Phone <span style={{color:'#999',fontWeight:400}}>(optional)</span></label>
          <input type="tel" placeholder="(970) 555-0100" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
        </div>

        <div className="form-group">
          <label className="form-label">I'd like to help with</label>
          <div className="pills" style={{ marginBottom: 0 }}>
            {INTERESTS.map(interest => (
              <span
                key={interest}
                className={`pill ${form.interests.includes(interest) ? 'on' : ''}`}
                onClick={() => toggleInterest(interest)}
              >
                {interest}
              </span>
            ))}
          </div>
        </div>

        {error && <div className="error-msg">{error}</div>}

        <button className="btn-red" style={{ height: 40, padding: '0 28px', fontSize: 14, marginTop: 8 }} onClick={handleSubmit} disabled={loading}>
          {loading
            ? <><Loader size={16} color="currentColor" style={{ verticalAlign: 'middle' }} /> Submitting...</>
            : <><CheckCircle size={16} color="currentColor" style={{ verticalAlign: 'middle' }} /> Sign me up</>}
        </button>
      </div>
    </div>
  );
};

export default Volunteer;
